module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [(_vm.interactionList.length > 0) ? _c('div', {
    staticClass: "con"
  }, [_vm._l((_vm.interactionList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "p-wrapper"
    }, [_c('div', {
      staticClass: "wrapper"
    }, [_c('div', {
      staticClass: "avatar",
      style: ({
        backgroundImage: ("url('" + (item.User.Avatar) + "')")
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('h1', {
      staticClass: "nickName"
    }, [_vm._v(_vm._s(item.User.Nickname))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.dateFormat(item.CreatedAt)))])]), _vm._v(" "), _c('p', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.Title))]), _vm._v(" "), _c('div', {
      staticClass: "imgList",
      on: {
        "click": function($event) {
          _vm.show(item.Picture, index)
        }
      }
    }, [_c('img', {
      ref: "pic",
      refInFor: true,
      staticClass: "imgWrap",
      attrs: {
        "id": index,
        "width": "100%",
        "src": item.Picture + '?imageMogr2/thumbnail/20000@/auto-orient',
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "like"
    }, [_c('div', {
      staticClass: "like-wrapper",
      on: {
        "click": function($event) {
          _vm.like(item.Id, index)
        }
      }
    }, [(item.isLiked) ? _c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-ShapeCopy1"
      }
    })]) : _c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-like1"
      }
    })]), _vm._v(" " + _vm._s(item.LikesCount))]), _vm._v(" "), _c('div', {
      staticClass: "comment-wrapper",
      on: {
        "click": function($event) {
          _vm.comment(item.Id, index)
        }
      }
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-icon222"
      }
    })]), _vm._v(" " + _vm._s(item.commentInfo.data.Total) + "\n            ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "inter-detail"
    }, [(item.LikesCount > 0) ? _c('div', {
      staticClass: "like"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-like1"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "wrapper"
    }, _vm._l((item.likeInfo.data.Result), function(user, i) {
      return _c('img', {
        key: i,
        staticClass: "avatar",
        attrs: {
          "src": user.Avatar,
          "alt": ""
        }
      })
    }))]) : _vm._e(), _vm._v(" "), (item.commentInfo.data.Total > 0) ? _c('div', {
      staticClass: "comment"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-icon222"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "wrapper"
    }, [_c('ul', _vm._l((item.commentInfo.data.Result), function(comment, i) {
      return _c('li', {
        key: i
      }, [_c('img', {
        staticClass: "avatar",
        attrs: {
          "src": comment.User.Avatar,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('p', {
        staticClass: "nickName"
      }, [_vm._v(_vm._s(comment.User.Nickname))]), _vm._v(" "), _c('p', {
        staticClass: "content"
      }, [_vm._v(_vm._s(comment.Content))])])])
    }))])]) : _vm._e()]), _vm._v(" "), (item.commentInfo.data.Total > 10 && item.commentInfo.data.Result.length < item.commentInfo.data.Total) ? _c('div', {
      staticClass: "readMore",
      on: {
        "click": function($event) {
          _vm.loadComment(index, item.Id, item.commentInfo.data, 10)
        }
      }
    }, [_c('h1', {
      class: {
        'is-act': _vm.isAct
      },
      on: {
        "touchend": _vm.touchend,
        "touchstart": _vm.touch
      }
    }, [_vm._v("查看更多")])]) : _vm._e()])
  }), _vm._v(" "), (_vm.interactionList.length > 0) ? _c('div', {
    staticClass: "loadTip"
  }, [_c('span', [_vm._v(_vm._s(_vm.loadMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "position": "right"
    },
    model: {
      value: (_vm.showComment),
      callback: function($$v) {
        _vm.showComment = $$v
      },
      expression: "showComment"
    }
  }, [_c('div', {
    staticClass: "comment-header"
  }, [_c('h1', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('h1', {
    staticClass: "publish",
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("发表")])]), _vm._v(" "), _c('group', [_c('x-textarea', {
    attrs: {
      "height": 200,
      "rows": 8,
      "cols": 30,
      "placeholder": "请输入评论内容",
      "max": 1000
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.previewerList,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    attrs: {
      "title": _vm.confirm_title
    },
    on: {
      "on-cancel": _vm.onCancel,
      "on-confirm": _vm.onConfirm,
      "on-show": _vm.onShow,
      "on-hide": _vm.onHide
    },
    model: {
      value: (_vm.showConfirm),
      callback: function($$v) {
        _vm.showConfirm = $$v
      },
      expression: "showConfirm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fresh",
    on: {
      "click": _vm.fetchMore
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shuaxin2"
    }
  })])])], 2) : _c('section', {
    staticClass: "noData"
  }, [_c('h1', [_vm._v("暂无数据")])]), _vm._v(" "), _c('wechat-share', {
    attrs: {
      "title": _vm.live.Title,
      "subTitle": _vm.live.SubTitle,
      "shareImg": _vm.live.ShareLogo
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47815fba"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Interaction/InteractionList.vue
// module id = 507
// module chunks = 1